<!--
 * @Author       : panyangyang
 * @Date         : 2026-08-27 16:48:20
 * @LastEditTime : 2026-09-11 09:07:21
 * @LastEditors  : panyangyang
 * @Description  :
 * @FilePath     : \ngs_platform_manage_admin\src\views\large-screen\right-panel\index.vue
-->
<template>
	<div class="right-panel">
		<!-- 流量转化漏斗 -->
		<div class="card right-bg1">
			<div class="card-header">代理机构收入贡献排名</div>
			<div class="card-content">
				<div class="user-statistics">
					<div v-for="(item, index) in flowArr" :key="item.name" class="stat-item">
						<!-- 标题行 -->
						<div class="stat-header">
							<div class="stat-name">
								<span class="rank">TOP {{ index + 1 }}</span>
								<span :title="item.name">{{ item.name.slice(0, 4) }}</span>
								<span class="bd-num">标段数：{{ item.bdNum }}个</span>
								<span class="shouru">贡献收入：{{ item.shouru }}</span>
							</div>

							<div class="stat-percent">{{ item.value }} %</div>
						</div>

						<!-- 进度条 -->
						<div class="bar-track">
							<div
								class="bar-value"
								:class="[index === 0 ? 'blue' : index === 1 ? 'purple' : index === 2 ? 'cyan' : 'yellow']"
								:style="{ width: item.value + '%' }"
							></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 用户画像 -->
		<div class="card right-bg2">
			<div class="card-header">
				<div class="tab flex">
					<div
						v-for="(item, index) in portraitType"
						:key="index + 'portraitType'"
						:class="{ 'tab-item-line line2': true, active: item.name == activePortraitType }"
						@click="changePortraitType(item)"
					>
						<span class="line"></span>
						{{ item.label }}
					</div>
				</div>
			</div>
			<div ref="portraitPieChart" class="chart-container"></div>
		</div>

		<!-- 主要城市数据 -->
		<div class="card right-bg3">
			<div class="card-header">主要城市数据</div>
			<div ref="cityBarChart" class="chart-container"></div>
		</div>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import { debounce } from '@/utils/tools.js'

export default {
	props: {
		// 右侧数据
		rightData: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			flowArr: [], // 代理机构收入贡献排名
			activePortraitType: '1',
			portraitType: [
				{ label: '用户画像', name: '1' },
				{ label: '项目画像', name: '2' }
			],
			picArr: [], // 用户画像
			projectBudgetArr: [], // 项目画像-预算
			projectArr: [], // 项目画像-项目类型
			cityArr: [], // 主要城市数据
			charts: {}
		}
	},
	created() {
		this.showData()
	},
	mounted() {
		this.handleResize = debounce(() => {
			this.resizeCharts()
		}, 100)
		// 监听窗口尺寸变化
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize)
		Object.values(this.charts).forEach((chart) => {
			if (chart) chart.dispose()
		})
	},
	methods: {
		// 展示数据
		showData() {
			const { flowArr = [], picArr = [], cityArr = [], projectBudgetArr = [], projectArr = [] } = this.rightData

			this.flowArr = flowArr // 代理机构收入贡献排名
			this.picArr = picArr // 用户画像
			this.projectBudgetArr = projectBudgetArr // 项目画像-预算
			this.projectArr = projectArr // 项目画像-项目类型
			this.cityArr = cityArr

			// 初始化图表
			setTimeout(() => {
				this.initCharts()
			}, 200)
		},

		// 切换用户画像
		changePortraitType(item) {
			this.activePortraitType = item.name
			this.charts.portrait.dispose()
			setTimeout(() => {
				this.initPortraitChart()
			}, 500)
		},

		// 初始化图表
		initCharts() {
			this.initPortraitChart()
			this.initCityBarChart()
		},

		// 用户画像饼图
		initPortraitChart() {
			const chart = echarts.init(this.$refs.portraitPieChart)
			const option1 = {
				tooltip: {
					trigger: 'item'
				},
				series: [
					{
						name: '用户画像',
						type: 'pie',
						// roseType: 'area',
						// radius: ['10%', '60%'],
						center: ['50%', '50%'],
						minAngle: 5, // 最小角度，单位是度
						avoidLabelOverlap: true,
						itemStyle: {
							borderRadius: 5,
							borderColor: '#0a1a2f',
							borderWidth: 2
						},
						label: {
							show: false,
							formatter: '{b}\n{d}%',
							color: '#fff'
						},
						tooltip: { formatter: '{a}<br/> {b} : {c} ({d}%)' },
						itemStyle: {
							borderRadius: 5
						},
						data: this.picArr
					}
				]
			}
			const option2 = {
				tooltip: {
					trigger: 'item'
				},
				series: [
					{
						name: '项目画像-预算',
						type: 'pie',
						// roseType: 'area',
						// radius: ['10%', '60%'],
						center: ['25%', '50%'],
						minAngle: 5, // 最小角度，单位是度
						avoidLabelOverlap: true,
						itemStyle: {
							borderRadius: 5,
							borderColor: '#0a1a2f',
							borderWidth: 2
						},
						label: {
							show: false,
							formatter: '{b}\n{d}%',
							color: '#fff'
						},
						tooltip: { formatter: '{a}<br/> {b} : {c} ({d}%)' },
						itemStyle: {
							borderRadius: 5
						},
						data: this.projectBudgetArr
					},
					{
						name: '项目画像-项目类型',
						type: 'pie',
						// roseType: 'area',
						// radius: ['10%', '60%'],
						center: ['75%', '50%'],
						minAngle: 5, // 最小角度，单位是度
						avoidLabelOverlap: true,
						itemStyle: {
							borderRadius: 5,
							borderColor: '#0a1a2f',
							borderWidth: 2
						},
						label: {
							show: false,
							formatter: '{b}\n{d}%',
							color: '#fff'
						},
						itemStyle: {
							borderRadius: 5
						},
						tooltip: { formatter: '{a}<br/> {b} : {c} ({d}%)' },
						data: this.projectArr
					}
				]
			}
			chart.setOption(this.activePortraitType == '1' ? option1 : option2)
			this.charts.portrait = chart
		},

		// 主要城市柱状图
		initCityBarChart() {
			if (!this.cityArr || this.cityArr.length < 0) {
				return
			}

			const chart = echarts.init(this.$refs.cityBarChart)
			let names = []
			let values = []
			this.cityArr.map((i) => {
				names.push(i.name)
				values.push(i.value)
			})

			const option = {
				tooltip: {
					trigger: 'axis'
				},
				color: ['#4BDE80'],
				grid: { left: '3%', right: '4%', bottom: '3%', top: '20%', containLabel: true },

				xAxis: {
					type: 'category',
					axisLabel: {
						color: '#C5DCFF'
					},
					axisTick: {
						show: false
					},
					data: names
				},
				yAxis: {
					type: 'value',
					name: '项目数量（个）',
					axisLabel: {
						color: '#C5DCFF'
					},
					nameTextStyle: {
						color: '#C5DCFF',
						padding: [0, 0, 0, 80]
					},
					splitLine: {
						lineStyle: {
							color: '#39A1FF'
						}
					}
				},
				series: [
					{
						type: 'bar',
						barWidth: '23',
						data: values,
						itemStyle: {
							borderRadius: [5, 5, 0, 0],
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{ offset: 0, color: '#D66903' },
									{ offset: 1, color: '#FAEF1A' }
								]
							}
						},
						label: {
							show: true,
							position: 'top',
							color: '#fff'
						}
					}
				]
			}
			chart.setOption(option)
			this.charts.city = chart
		},

		// 窗口大小变化时重置图表
		resizeCharts() {
			Object.values(this.charts).forEach((chart) => {
				if (chart) chart.resize()
			})
		}
	},
	watch: {
		rightData: {
			deep: true,
			handler() {
				this.showData()
			}
		}
	}
}
</script>

<style lang="less" scoped>
// 文字颜色渐变
.text-gradient {
	background-image: linear-gradient(to bottom, #76b6f5 0%, #edf4fc 100%);
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}
// 背景图设置
.image-set {
	background-size: 100% 100%;
	background-repeat: no-repeat;
}

.right-panel {
	// width: 470px;
	width: 25.3%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-height: 0;
}

.right-bg1 {
	width: 100%;
	height: 40%;
	// height: 363px;
	background-image: url('~@/assets/images/screen/right-bg1.jpg');
	.image-set;
}

.right-bg2 {
	width: 100%;
	height: 30%;
	// height: 290px;
	background-image: url('~@/assets/images/screen/right-bg2.jpg');
	.image-set;
}

.right-bg3 {
	width: 100%;
	height: 30%;
	// height: 290px;
	background-image: url('~@/assets/images/screen/right-bg2.jpg');
	.image-set;
}

.user-statistics {
	width: 100%;
	box-sizing: border-box;
	color: #b8c9e7;
}

.stat-item {
	margin-bottom: 9px;

	&:last-child {
		margin-bottom: 0;
	}
}

.stat-header {
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 13px;
	line-height: 20px;
}

.stat-name {
	flex: 1;
	display: flex;

	.bd-num {
		width: 28%;
		margin-left: 15px;
	}

	.shouru {
		flex: 1;
	}
}

.rank {
	margin-right: 13px;
	color: #b4c8e8;
	font-size: 12px;
	font-family: Arial, sans-serif;
	letter-spacing: 0.6px;
}

.stat-percent {
	width: 43px;
	text-align: right;
	color: #c9d7ef;
	font-size: 14px;
}

.bar-track {
	position: relative;
	height: 12px;
	padding: 2px;
	box-sizing: border-box;
	overflow: hidden;
	border-radius: 8px;

	background: #02133d;
	border: 1px solid rgba(66, 116, 188, 0.25);
	box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.65), 0 0 2px rgba(8, 64, 140, 0.35);
}

.bar-value {
	height: 100%;
	border-radius: 7px;
	transition: width 0.8s ease;
}

/* TOP 1 */
.bar-value.blue {
	background: linear-gradient(90deg, #2158a2 0%, #82c6f7 100%);
}

/* TOP 2 */
.bar-value.purple {
	background: linear-gradient(90deg, #3f3cba 0%, #657cff 100%);
}

/* TOP 3 */
.bar-value.cyan {
	background: linear-gradient(90deg, #10646c 0%, #3bd5b4 100%);
}

/* TOP 4、5、6 */
.bar-value.yellow {
	background: linear-gradient(90deg, #605028 0%, #e6bd3e 100%);
}
</style>
